
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/begin-skiseizoen",
      function () {
        return require("private-next-pages/[region]/begin-skiseizoen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/begin-skiseizoen"])
      });
    }
  